import { baseUrl, jwtHeaders } from '../common/data';

export const verifyGstin = async (gstin, branchId) => {
  const response = await fetch(`${baseUrl}/api/gstin/verify/${gstin}?branchId=${branchId}`, {
    method: 'GET',
    headers: jwtHeaders(),
  });
  const resData = await response?.json();
  return resData;
};